export function getOrderPrice(orderinfo) {
    return parsePriceToShow(orderinfo.pricetotal)
}

export function parsePriceToShow(price) {
    return price
}